package Structs

import Structs.Api.Api
import Structs.Api.ApiNote
import Utils.DocType
import myName

@myName("InformationBase")
abstract class InformationBase {
    var fulled: Boolean = false

    @myName("apis")
    var apis: MutableList<ApiNote> = mutableListOf()
    @myName("getConnectedDate")
    abstract fun getConnectedDate(): String
    @myName("getConnectedId")
    abstract fun getConnectedId(): Int

    /** Visible document number (supplier tax notes: printed invoice number). */
    @myName("displayDocId")
    open fun displayDocId(): String = getConnectedId().toString()
    @myName("getConnectedEntId")
    abstract fun getConnectedEntId(): Int
    @myName("getConnectedValue")
    abstract fun getConnectedValue(): Float

    @myName("getConnectedName")
    abstract fun getConnectedName(): String
    @myName("getBussinessId")
    open fun getBusinessId(): String {
        return ""
    }

    @myName("getConnectedDateTime")
    open fun getConnectedDateTime(): String {
        return getConnectedDate()
    }

    @myName("getConnectedAgent")
    open fun getConnectedAgent(): String {
        return ""
    }
    @myName("getOpenValue")
    open fun getOpenValue(): Float {
        return 0f
    }
    @myName("getConnectedDocName")
    fun getConnectedDocName(): String {
        return DocType.TAX_NOTE_CANCEL.convert(getConnectedDocType()).DOC_NAME()
    }
    @myName("getAmounts")
    open fun getAmounts(): Float {
        return 0f
    }

    @myName("getAmountsSecond")
    open fun getAmountsSecond(): Float {
        return 0f
    }
    @myName("getReturnAmounts")
    open fun getReturnAmounts(): Float {
        return 0f
    }
    @myName("getConnectedTaxValueReal")
    open fun getConnectedTaxValueReal(): Float {
        return 0f
    }
    @myName("getBeforeValueReal")
    open fun getBeforeValueReal(): Float {
        return 0f
    }
    @myName("getConnectedValueReal")
    open fun getConnectedValueReal(): Float {
        return getConnectedValue()
    }
    @myName("getNotes2")
    open fun getNotesComment2(): String {
        return ""
    }
    @myName("getNotes3")
    open fun getNotesComment3(): String {
        return ""
    }
    @myName("getNotes4")
    open fun getNotesComment4(): String {
        return ""
    }
    @myName("getNotes5")
    open fun getNotesComment5(): String {
        return ""
    }
    @myName("getConnectedPayment")
    open fun getConnectedPayment(): Float {
        return 0f
    }
    @myName("getConnectedPaymentCash")
    open fun getConnectedPaymentCash(): Float {
        return 0f
    }
    @myName("getConnectedPaymentCheck")
    open fun getConnectedPaymentCheck(): Float {
        return 0f
    }
    @myName("getConnectedPaymentBank")
    open fun getConnectedPaymentBank(): Float {
        return 0f
    }
    @myName("getConnectedPaymentMass")
    open fun getConnectedPaymentMass(): Float {
        return 0f
    }
    @myName("getConnectedPaymentCredit")
    open fun getConnectedPaymentCredit(): Float {
        return 0f
    }
    @myName("getSign")
    open fun getSign(): Int {
        return 1
    }
    @myName("getConnectedDocNameShort")
    fun getConnectedDocNameShort(): String {
        return DocType.TAX_NOTE_CANCEL.convert(getConnectedDocType()).DOC_NAME_SHORT()
    }

    @myName("getConnectedDocType")
    open fun getConnectedDocType(): Int {
        return -1
    }

    @myName("getConnectedDocTypeStruct")
    open fun getConnectedDocTypeStruct(): DocType {
        return DocType.DELIVERY_NOTES.convert(getConnectedDocType())
    }


    @myName("isUsed")
    open fun isUsed(): Boolean {
        return true
    }
    @myName("isOClosed")
    open fun isOClosed(): Boolean {
        return isUsed()
    }

    @myName("isActive")
    open fun isActive(): Boolean {
        return true
    }

    @myName("getStoreNext")
    fun getStoreNext(): ApiNote? {
        return apis.firstOrNull { it.api_method == Api.STORENEXT.state }
    }

    @myName("getOne")
    fun getOne(): ApiNote? {
        return apis.firstOrNull { it.api_method == Api.ONE.state }
    }

    @myName("getManager")
    fun getManager(): ApiNote? {
        return apis.firstOrNull { it.api_method == Api.MANAGER.state }
    }
    @myName("getHashavshevet")
    fun getHashavshevet(): ApiNote? {
        return apis.firstOrNull { it.api_method == Api.HASHAVSHEVET.state }
    }

    private fun isExternalSoftwareApiMethod(apiMethod: Int): Boolean {
        return apiMethod != Api.EMAIL.state && apiMethod != Api.WHATSAPP.state
    }

    @myName("getExternalSoftwareNote")
    fun getExternalSoftwareNote(): ApiNote? {
        return apis.firstOrNull { isExternalSoftwareApiMethod(it.api_method) && it.send != 0 }
            ?: apis.firstOrNull { isExternalSoftwareApiMethod(it.api_method) }
    }

    @myName("isSentToExternalSoftware")
    fun isSentToExternalSoftware(): Boolean {
        return apis.any { isExternalSoftwareApiMethod(it.api_method) && it.send != 0 }
    }

    @myName("signData")
    open fun signData(): NoteSignHolder? = null

    @myName("digiSign")
    open fun digiSign(): Boolean = false

    @myName("digiPhoto")
    open fun digiPhoto(): Boolean = false

    @myName("photoCount")
    open fun photoCount(): Int = 0

    @myName("getComments")
    open fun getComments(): String {
        return ""
    }


    @myName("getConnectedProductsIds")
    open fun getConnectedProductsIds():List<Int> {
        return listOf()
    }
    @myName("getConnectedProductsDelivery")
    open fun getConnectedProductsDelivery():List<ProductDelivery> {
        return listOf()
    }
}